export default __webpack_public_path__ + "static/media/women-in-blue.c8be6386.png";